(function ($) {
  'use strict';
  var pending;
  window.ensureThrillSession = function () {
    if (window.csrfToken) return $.Deferred().resolve(window.csrfToken).promise();
    if (!pending) {
      pending = $.ajax({url:'/inc/ajax/session-bootstrap.aspx',dataType:'json',cache:false}).then(function (data) {
        if (!data || !data.csrfToken) return $.Deferred().reject('missing_csrf_token').promise();
        window.csrfToken=data.csrfToken;
        window.browseSessionDeferred=window.categorySessionDeferred=window.productSessionDeferred=false;
        window.dispatchEvent(new Event('thrill-session-ready'));
        return window.csrfToken;
      });
      pending.always(function(){pending=null;});
    }
    return pending;
  };
})(window.jQuery);
